// cfgmenus

const getters = {
	getCfgMenus(state) {
		return state.cfgmenus;
	},

};

export default getters;